import {
  faDownload,
  faEye,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import "./Review_contract_table.css";
import Certification_Modal from "../../../../../../../common/common_modal/certification_modal/Certification_Modal";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

function Review_contract_table() {
  const [showModal, setModal] = useState(false);

  const data = [
    {
      employeeId: "CUST001",
      employeeName: "ABC Coal Traders",
      employeeDesignation: "Industry",
      attachedFile: "Upload file",
    },
    {
      employeeId: "CUST001",
      employeeName: "ABC Coal Traders",
      employeeDesignation: "Industry",
      attachedFile: "Upload file",
    },
    {
      employeeId: "CUST001",
      employeeName: "ABC Coal Traders",
      employeeDesignation: "Industry",
      attachedFile: "Empid1001.PDF",
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th>Employee ID</th>
                  <th>Employee Name</th>
                  <th>Designation</th>
                  <th>Attached File</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {paginatedData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.employeeId}</td>
                    <td>{row.employeeName}</td>
                    <td>{row.employeeDesignation}</td>

                    <td
                      className={`status attachedFileStatus ${
                        row.attachedFile === "Upload file"
                          ? "in_active"
                          : "active"
                      }`}
                    >
                      {row.attachedFile}
                    </td>

                    <td>
                      <div className="action_icons">
                        <FontAwesomeIcon
                          icon={faEye}
                          onClick={() => setModal(true)}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>

      <Certification_Modal
        show={showModal}
        onHide={() => setModal(false)}
        modalHeadingText={"Review Of Request , Tenders & Contract"}
        imgSrc={"/assets/images/cerificate/certi.png"}
        btnText={"Download"}
      />
    </>
  );
}

export default Review_contract_table;
